import VueC from 'vue';
import * as Vue from 'vue-tsx-support';
import { Component, Prop } from 'vue-property-decorator';
import './infoWindow.less';
import { createBEM } from 'src/util/bem';
import { StationListDOI } from 'src/pages/stationList/api/stationListApi';
import EnumStationType from 'src/enums/enumStationType';
import EnumWaterLever from 'src/enums/enumWaterLever';
import DataViewApi from 'src/pages/dataManage/dataView/api/dataViewApi';
import EnumDeviceStatus from 'src/enums/enumDeviceStatus';
import StationListService from 'src/pages/stationList/service/stationListService';
import RouteUtils from 'src/util/routeUtils';
import Switch from 'src/types/iview/Switch';
import EnumWarningNotice from 'src/enums/enumWarningNotice';
import StationDetailApi from 'src/pages/stationDetail/api/stationDetailApi';
import EnumControlLevel from 'src/enums/enumControlLevel';
let bem = createBEM('info-window');

@Component
class InfoWindow extends Vue.Component<{ data: StationListDOI.RowDataI }> {
    @Prop({
        type: Object,
    })
    data!: StationListDOI.RowDataI;

    realTime: string = '';

    list: { name: string; value: string }[] = [];
    itv:any

    async mounted() {
        this.test()
        this.itv = setInterval(()=> {
            this.test()
        },1000 * 30)
    }
    //实例销毁之前调用
    beforeDestroy() {
        //销毁计时器
        clearInterval(this.itv)
    }
    async test()
    {
        let { code, data } = await DataViewApi.getRealTimeData(this.data.mn);
        if (code === 0) {
            let obj: any = data.body[0];
            this.realTime = obj.DateTime;
            this.list = data.header.map(i => {
                return {
                    name: i.name,
                    value: obj[i.key] + i.unit,
                };
            });
        }
    }
    video() {
        RouteUtils.goToWidthCache(`/${EnumStationType.findId(this.data.type).getCode()}/detection/station/video`, {
            mn: this.data.mn + '',
            productId: this.data.product_id,
            id: this.data.id,
            factorset: this.data.factorset,
            type: this.data.type,
        });
    }
    async changeAlarm(open) {
        let status = open?EnumWarningNotice.Open.getId():EnumWarningNotice.Close.getId()
        this.data.is_warning_notice = status
        StationDetailApi.changeAlarmNotice(this.data.id, status)
    }
    render(h) {
        return (
            <div class={bem()}>
                <div
                    class={bem('station-detail')}
                    onClick={() => {
                        StationListService.goToStationDetail(this.data.type, this.data);
                    }}
                >
                    站点详情
                </div>
                <div class={bem('title')}>
                    <span class={bem('title-text')} title={this.data.name}>
                        {this.data.name}
                    </span>
                    <span
                        class={bem('tag', {
                            malfunction: this.data.device_status === EnumDeviceStatus.Malfunction.getId(),
                            overproof: this.data.device_status === EnumDeviceStatus.Offline.getId(),
                        })}
                    >
                        {EnumDeviceStatus.findId(this.data.device_status).getName()}
                    </span>
                    <span class="wqms-font icon-jiankong" on-click={this.video.bind(this)}></span>
                </div>
                <row class={bem('station-info')} gutter={10}>
                    <div style="overflow: hidden">
                        <i-col span={8} v-if={this.data.type === EnumStationType.Water.getId()}>
                            目标等级：<span class={bem('level')}>{EnumWaterLever.findId(this.data.water_level).getName()}</span>
                        </i-col>
                        <i-col span={8} v-else>
                            检测类别：<span >{this.data.section}</span>
                        </i-col>
                        <i-col span={16} >
                            控制级别：<span >{EnumControlLevel.findId(this.data.control_hierarchy).getName()}</span>
                        </i-col>
                    </div>
                    <i-col span={8}>
                            报警通知：<Switch size="large" value={this.data.is_warning_notice === EnumWarningNotice.Open.getId()} on-on-change={this.changeAlarm.bind(this)}>
                                <span slot="open">ON</span>
                                <span slot="close">OFF</span>
                            </Switch>
                        </i-col>
                    <i-col span={8}>站点类型：{EnumStationType.Water.getId() === this.data.type ? '地表水' : '污染源'}</i-col>
                    <i-col span={8}>流域：{this.data.basin}</i-col>
                    <i-col span={24}>地址：{this.data.address}</i-col>
                </row>
                <div class={bem('data-title')}>实时数据 {this.realTime}</div>
                <row class={bem('data')} gutter={10}>
                    {this.list.map(i => {
                        return (
                            <i-col span={8} key={i.name}>
                                <div class={bem('data-name')}>{i.name}</div>
                                <div class={bem('data-value')}>{i.value}</div>
                            </i-col>
                        );
                    })}
                </row>
            </div>
        );
    }
}

export default function alertInfoWindow(id: string, data: StationListDOI.RowDataI) {
    return new VueC({
        render: h => h(InfoWindow, { props: { data } }),
    }).$mount(document.getElementById(id)!);
}
